// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".items[data-v-b54aa84a]{display:grid;grid-template-columns:repeat(auto-fill,200px);grid-gap:16px;justify-content:space-between;padding:16px}", ""]);
// Exports
module.exports = exports;
